import { render, staticRenderFns } from "./ConfigurationFlags.vue?vue&type=template&id=296bfa7b"
import script from "./ConfigurationFlags.vue?vue&type=script&lang=js"
export * from "./ConfigurationFlags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports